<div class="content">

  <div class="header">{{ 'bikeshop.shop_profile.collections.delivery_areas' | translate }}</div>

  <div class="row margin-top-16">
    <div class="col-md-4 label" [ngClass]="{invalid: !data.areaName}">
      {{
      'bikeshop.shop_profile.collections.area_name' |
      translate
      }}
    </div>
    <div class="col-md-8">
      <input type="text" pInputText [(ngModel)]="data.areaName" />
    </div>
  </div>

  <!-- <div class="row margin-top-16">
    <div class="col-md-4 label">{{ 'bikeshop.shop_profile.collections.can_do_collections' | translate }}</div>
    <div class="col-md-2">
      <p-inputSwitch [(ngModel)]="data.canDoCollections"></p-inputSwitch>
    </div>
  </div>

  <div class="row margin-top-16">
    <div class="col-md-4 label">{{ 'bikeshop.shop_profile.collections.can_do_deliveries' | translate }}</div>
    <div class="col-md-2">
      <p-inputSwitch [(ngModel)]="data.canDoDeliveries"></p-inputSwitch>
    </div>
  </div> -->

  <div class="row margin-top-16">
    <div class="col-md-4 label" style="margin-top: 0px;" [ngClass]="{invalid: !pointList || pointList.length === 0}">
      {{
      'bikeshop.shop_profile.collections.create_area' | translate
      }}
      <div><small>{{ 'bikeshop.shop_profile.collections.create_area_description' | translate }}</small></div>
      <br />

      <div style="margin-top: 4px;display: flex;column-gap: 8px;" *ngIf="areaColours && areaColours.length > 1">
        <p-checkbox [(ngModel)]="showAllMaps" [binary]="true" (onChange)="selectDeselectAllMaps()"></p-checkbox>
        <div class="label">{{'general.select_deselect_all' | translate}}</div>
      </div>
      <div *ngIf="areaColours && areaColours.length > 1">
        <div *ngFor="let areaColour of areaColours" style="margin-top: 4px;display: flex;column-gap: 8px;">
          <p-checkbox [(ngModel)]="areaColour.showOnMap" [binary]="true" (onChange)="redrawMaps()"
            [disabled]="data.areaName == areaColour.area"></p-checkbox>
          <div class="label" [ngStyle]="{ 'color': areaColour.colour }">{{areaColour.area}}</div>
        </div>
      </div>
    </div>
    <div class="col-md-8">
      <agm-map [zoom]="11" [latitude]="currentStoreCoords.lat" [longitude]="currentStoreCoords.lng"
        [fullscreenControl]="true" (mapReady)="onMapReady($event)"></agm-map>
    </div>
  </div>
  <div class="row" *ngIf="selectedShape">
    <div class="col-md-4 label">
    </div>
    <div class="col-md-8">
      <button pButton (click)="deleteSelectedShape()" class="p-button-raised full-width alternate"
        label="{{'bikeshop.shop_profile.collections.reset_map' | translate}}"></button>
    </div>
  </div>
</div>

<div *ngIf="isWorkshop">
  <div class="content">
    <div class="row">
      <div class="col-md-4 label">
        {{
        'bikeshop.shop_profile.collections.collection_fee' | translate
        }}
      </div>
      <div class="col-md-4">
        <div class="sku-active" *ngIf="data.collectionProduct && data.collectionProduct.productID">
          <span class="fa fa-times" (click)="clearCollectionSKU()"></span>{{data.collectionProduct.sku}}
        </div>
        <div *ngIf="!data.collectionProduct">
          <p-autoComplete [suggestions]="searchResult" [delay]="1000" placeholder="{{
            'bikeshop.modal.add_edit_service_types.linked_skus_form.enter_sku_or_name'
              | translate
          }}" (completeMethod)="searchProducts($event)" (onSelect)="linkCollectionSku($event)">
            <ng-template let-product pTemplate="item">
              <div>
                <span>{{ product.SKU }} - {{ product.Name }}</span>
              </div>
            </ng-template>
          </p-autoComplete>
        </div>
      </div>
    </div>
  </div>

  <div class="content">
    <div class="row">
      <div class="col-md-4 label">
        {{
        'bikeshop.shop_profile.collections.delivery_fee' | translate
        }}
      </div>
      <div class="col-md-4">
        <div class="sku-active" *ngIf="data.deliveryProduct && data.deliveryProduct.productID">
          <span class="fa fa-times" (click)="clearDeliverySKU()"></span>{{data.deliveryProduct.sku}}
        </div>
        <div *ngIf="!data.deliveryProduct">
          <p-autoComplete field="sku" [suggestions]="searchResult" [delay]="1000" placeholder="{{
            'bikeshop.modal.add_edit_service_types.linked_skus_form.enter_sku_or_name'
              | translate
          }}" (completeMethod)="searchProducts($event)" (onSelect)="linkDeliverySku($event)">
            <ng-template let-product pTemplate="item">
              <div>
                <span>{{ product.SKU }} - {{ product.Name }}</span>
              </div>
            </ng-template>
          </p-autoComplete>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isRentals">
  <div class="content">
    <div class="row">
      <div class="col-md-4 label">
        {{
        'bikeshop.shop_profile.collections.delivery_fee' | translate
        }}
      </div>
      <div class="col-md-4">
        <div class="sku-active" *ngIf="data.deliveryProduct && data.deliveryProduct.productID">
          <span class="fa fa-times" (click)="clearDeliverySKU()"></span>{{data.deliveryProduct.sku}}
        </div>
        <div *ngIf="!data.deliveryProduct">
          <p-autoComplete field="sku" [suggestions]="searchResult" [delay]="1000" placeholder="{{
            'bikeshop.modal.add_edit_service_types.linked_skus_form.enter_sku_or_name'
              | translate
          }}" (completeMethod)="searchProducts($event)" (onSelect)="linkDeliverySku($event)">
            <ng-template let-product pTemplate="item">
              <div>
                <span>{{ product.SKU }} - {{ product.Name }}</span>
              </div>
            </ng-template>
          </p-autoComplete>
        </div>
      </div>
    </div>
  </div>
  <div class="content">
    <div class="row">
      <div class="col-md-4 label">
        {{
        'bikeshop.shop_profile.collections.collection_fee' | translate
        }}
      </div>
      <div class="col-md-4">
        <div class="sku-active" *ngIf="data.collectionProduct && data.collectionProduct.productID">
          <span class="fa fa-times" (click)="clearCollectionSKU()"></span>{{data.collectionProduct.sku}}
        </div>
        <div *ngIf="!data.collectionProduct">
          <p-autoComplete [suggestions]="searchResult" [delay]="1000" placeholder="{{
            'bikeshop.modal.add_edit_service_types.linked_skus_form.enter_sku_or_name'
              | translate
          }}" (completeMethod)="searchProducts($event)" (onSelect)="linkCollectionSku($event)">
            <ng-template let-product pTemplate="item">
              <div>
                <span>{{ product.SKU }} - {{ product.Name }}</span>
              </div>
            </ng-template>
          </p-autoComplete>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="content">
  <div class="row">
    <div class="col-md-4 label" style="margin-top: 0px;"
      [ngClass]="{invalid: !selectedPartners || selectedPartners.length === 0}">
      {{
      'bikeshop.shop_profile.collections.link_to_stores' | translate
      }}
    </div>
    <div class="col-md-4 partners">
      <div *ngFor="let partner of linkedPartners">
        <div>
          <p-checkbox name="linkedPartners" value="{{partner.partnerID}}" [(ngModel)]="selectedPartners"
            [disabled]="linkedPartners.length === 1">
          </p-checkbox>
        </div>
        <div class="label">{{partner.partnerName}}</div>
      </div>
    </div>
  </div>
</div>

<div class="content">
  <div class="row margin-bottom-16" *ngIf="!valid()">
    <div class="col-md-12 invalid">{{ 'bikeshop.shop_profile.collections.validation_message' | translate }}</div>
  </div>

  <div class="row">
    <div class="col-md-8 label"></div>
    <div class="col-md-4">
      <button pButton (click)="save()" class="p-button-raised full-width p-mini" [ngClass]="{'busy': saving}"
        label="{{ (saving ? 'bikeshop.general.busy' : data.id ? 'bikeshop.general.update' : 'bikeshop.general.save') | translate}}"
        [disabled]="saving || !valid()"></button>
    </div>
  </div>
</div>